import {FC} from 'react';
import {Box} from '@mui/material';
import {AiAgentChartData} from 'src/types';
import {CHART_METRICS, ChatChart} from './ChatChart';

interface ChartExportRigProps {
    charts: AiAgentChartData[];
}

// Off-screen render used ONLY during a PDF export: for every chart it renders the real
// ChatChart once per metric (Energy / Cost / Sessions / Avg price) at a fixed size, so
// the export can capture all four views — not just whichever metric was on screen.
// Rendered inside the app tree (so it inherits react-intl / MUI theme), but positioned
// far off-screen. NOT `display:none` — that would give the SVG zero size and break
// capture. Each cell is tagged so `captureExportCharts()` can find + key it.
const rigWrap = {position: 'absolute' as const, left: -100000, top: 0, width: 780, opacity: 0, pointerEvents: 'none' as const};
const cell = {width: 780, height: 360};

export const ChartExportRig: FC<ChartExportRigProps> = ({charts}) => (
    <Box sx={rigWrap} aria-hidden>
        {charts.map((chart, chartIdx) =>
            CHART_METRICS.map((m) => (
                <Box
                    key={`${chartIdx}:${m.key}`}
                    sx={cell}
                    data-ai-export-chart=""
                    data-chart-idx={chartIdx}
                    data-metric={m.key}
                >
                    <ChatChart data={chart} forcedMetric={m.key} />
                </Box>
            )),
        )}
    </Box>
);
